import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    LinearProgress,
    IconButton,
} from '@material-ui/core';
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PauseIcon from "@mui/icons-material/Pause";
import CancelIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const UploadBox = styled(Box)(({ theme }) => ({
    border: `2px dashed ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4),
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: theme.palette.background.default,
    marginTop: theme.spacing(2),
    "&:hover": {
        backgroundColor: theme.palette.action.hover,
    },
}));

class UploadFileDialog extends React.Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
    }

    state = {
        uploading: false,
        uploadProgress: 0,
        isPaused: false,
        fileName: "",
    };

    componentWillUnmount() {
        clearInterval(this.uploadInterval);
    }


    handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({
                uploading: true,
                uploadProgress: 0,
                isPaused: false,
                fileName: file.name,
            });

            if (this.props.onUpload) {
                this.props
                    .onUpload(file, (progress) => {
                        this.setState({ uploadProgress: progress });
                    })
                    .then(() => {
                        this.setState({ uploading: false, uploadProgress: 100 },()=>{

                            // Close the dialog after 3s delay
                            setTimeout(() => {
                                this.props.onClose();
                            }, 1000);
                        });


                    })
                    .catch((err) => {
                        console.error('Upload failed:', err);
                        this.setState({ uploading: false });
                    });
            }
        }
    };




    handlePauseResume = () => {
        this.setState((prev) => ({ isPaused: !prev.isPaused }));
    };

    handleCancelUpload = () => {
        clearInterval(this.uploadInterval);
        this.setState({
            uploading: false,
            uploadProgress: 0,
            isPaused: false,
            fileName: "",
        });
    };

    render() {
        const { open, onClose } = this.props;
        const { uploading, uploadProgress, isPaused, fileName } = this.state;

        return (
            <Dialog
                disableEnforceFocus
                disableRestoreFocus
                open={open}
                onClose={() => {
                    if (!uploading) onClose();
                }}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Upload File</DialogTitle>
                <DialogContent>
                    {!uploading ? (
                        <>
                            <UploadBox
                                onClick={() => this.fileInputRef.current.click()}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        this.fileInputRef.current.click();
                                    }
                                }}
                                aria-label="File upload dropzone"
                            >
                                <CloudUploadIcon sx={{ fontSize: 40, color: "text.secondary" }} />
                                <Typography variant="h6" gutterBottom>
                                    click to upload
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Supported formats: PDF, DOCX, PNG, JPG
                                </Typography>
                            </UploadBox>
                            <input
                                type="file"
                                accept=".pdf,.docx,.png,.jpg,.jpeg"
                                ref={this.fileInputRef}
                                onChange={this.handleFileUpload}
                                style={{ display: "none" }}
                            />
                        </>
                    ) : (
                        <Box mt={2}>
                            <Typography variant="body1" gutterBottom>
                                Uploading: {fileName}
                            </Typography>
                            <LinearProgress variant="determinate" value={uploadProgress} />
                            <Box mt={1} display="flex" justifyContent="flex-end" alignItems="center">
                                <Typography variant="body2" mr={1}>
                                    {uploadProgress}%
                                </Typography>
                                <IconButton onClick={this.handlePauseResume} size="small" aria-label={isPaused ? "Resume upload" : "Pause upload"}>
                                    {isPaused ? <PlayArrowIcon /> : <PauseIcon />}
                                </IconButton>
                                <IconButton onClick={this.handleCancelUpload} size="small" aria-label="Cancel upload">
                                    <CancelIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{backgroundColor:""}}
                        className="register-new-user_btn"
                        onClick={() => {
                            if (!uploading) onClose();
                        }}
                        disabled={uploading}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default UploadFileDialog;
